import React from 'react'
import {
  Card,
  Input,
  Checkbox,
  Button,
  Typography,
} from "@material-tailwind/react";
import { auth,signInWithEmailAndPassword } from '../../config/firebase';
import Swal from 'sweetalert2';
export default function SignIn() {
const login=()=>{
 let email=document.getElementById("email").value;
 let password=document.getElementById("pass").value;
 signInWithEmailAndPassword(auth, email, password)
 .then((userCredential) => {
   const user = userCredential.user;
   Swal.fire({
    icon: 'success',
    title: 'Login Successfull.',
    
}).then(()=>{
  window.location.href="../Dashboard"
})
 })
 .catch((error) => {
   const errorCode = error.code;
   const errorMessage = error.message;
   Swal.fire({
    icon: 'error',
    title: errorMessage,
})
  });



}

  return (
    <div  className='flex justify-center h-screen items-center '>
      <div className='w-4/12 shadow-2xl border-2 flex justify-center'>


  <Card color="transparent" className='  ' shadow={false}>
      <Typography variant="h4" className='text-center' color="blue-gray">
        Sign In
      </Typography>
      <Typography color="gray" className="mt-1 text-center font-normal">
        Enter your details to register.
      </Typography>
      <form className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96 " >
        <div className="mb-4 flex flex-col gap-6">
        
          <Input id='email' type='email' size="lg" label="Email" />
          <Input id='pass'  type="password" size="lg" label="Password" />
        </div>
        <Checkbox
          label={
            <Typography
              variant="small"
              color="gray"
              className="flex items-center font-normal"
            >
              I agree the
              <a
                href="#"
                className="font-medium transition-colors hover:text-gray-900"
              >
                &nbsp;Terms and Conditions
              </a>
            </Typography>
          }
          containerProps={{ className: "-ml-2.5" }}
        />
        <Button onClick={login} className="mt-6" fullWidth>
          Login
        </Button>
     <br />
      </form>
    </Card>
    </div>
    </div>
  )
}
